export default function Labels() {
  return (
    <b>test</b>
  )
}
